class AutoRefreshScheduler {
    constructor(config) {
        this.scheduleType = config.scheduleType || 'fixed-30';
        this.intervalMinutes = config.intervalMinutes || 5;

        const defaultMaxCount = this.scheduleType === 'interval' ? Math.ceil(180 / this.intervalMinutes) : 6;
        this.maxRefreshCount = config.maxRefreshCount || defaultMaxCount;
        
        this.idleThresholdMs = config.idleThresholdMs || 5 * 60 * 1000;
        this.onRefresh = config.onRefresh;
        this.name = config.name || 'Scheduler';
        
        this.refreshCount = 0;
        this.gsapCall = null;
        this.lastInteractionTime = Date.now();

        this.handleUserInteraction = () => {
            this.lastInteractionTime = Date.now();
            if (this.refreshCount >= this.maxRefreshCount) {
                this.refreshCount = 0;
                this.scheduleNext();
            } else {
                this.refreshCount = 0;
            }
        };
    }

    start() {
        window.addEventListener('click', this.handleUserInteraction);
        window.addEventListener('keydown', this.handleUserInteraction);

        if (window.gsap) {
            gsap.delayedCall(2, () => this.scheduleNext());
        } else {
            const self = this;
            requestAnimationFrame(function waitForGsapInit() {
                if (window.gsap) gsap.delayedCall(2, () => self.scheduleNext());
                else requestAnimationFrame(waitForGsapInit);
            });
        }
    }

    stop() {
        window.removeEventListener('click', this.handleUserInteraction);
        window.removeEventListener('keydown', this.handleUserInteraction);
        if (this.gsapCall && window.gsap) {
            this.gsapCall.kill();
        }
    }

    scheduleNext() {
        if (this.refreshCount >= this.maxRefreshCount) return;

        const now = new Date();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();
        
        let secondsToWait = 0;

        if (this.scheduleType === 'fixed-30') {
            let nextTargetMinute;
            if (minutes < 20) {
                nextTargetMinute = 20;
            } else if (minutes < 50) {
                nextTargetMinute = 50;
            } else {
                nextTargetMinute = 80;
            }
            
            const minutesToWait = nextTargetMinute - minutes;
            secondsToWait = (minutesToWait * 60) - seconds;
        } else if (this.scheduleType === 'interval') {
            const remainder = minutes % this.intervalMinutes;
            const minutesToWait = this.intervalMinutes - remainder;
            secondsToWait = (minutesToWait * 60) - seconds;
        }
        
        if (this.gsapCall && window.gsap) {
            this.gsapCall.kill();
        }
        
        if (window.gsap) {
            const scheduledTime = new Date(Date.now() + secondsToWait * 1000);
            console.log(`[${this.name}] Next refresh scheduled for: ${scheduledTime.toLocaleTimeString()} (in ${Math.round(secondsToWait)}s)`);
            
            this.gsapCall = gsap.delayedCall(secondsToWait, () => {
                this.executeRefresh();
            });
        }
    }

    executeRefresh() {
        const idleTime = Date.now() - this.lastInteractionTime;
        
        if (idleTime < this.idleThresholdMs) {
            console.log(`[${this.name}] Skipping refresh (user active). Idle time: ${Math.round(idleTime/1000)}s, Threshold: ${this.idleThresholdMs/1000}s`);
            this.refreshCount = 0;
            this.scheduleNext();
            return;
        }

        console.log(`[${this.name}] Executing refresh now! (Idle time: ${Math.round(idleTime/1000)}s)`);
        this.refreshCount++;
        
        if (typeof this.onRefresh === 'function') {
            this.onRefresh();
        }
        
        this.scheduleNext();
    }
}

window.AutoRefreshScheduler = AutoRefreshScheduler;
